import { 
    Component, ReactNode
} from 'react'

import { UserType } from '../../slices/LoginSlice'

import { loginIcon } from '../../incons/icons'

import LoginModal from '../modal/LoginModal'
import RegisterModal from '../modal/RegisterModal'


interface Props {
    updateUserCallBack: Function
}

interface Status {
    buttonsLayerIsOpen: boolean
    modalLoginIsOpen: boolean
    modalRegisterIsOpen: boolean
}

class LoginDropDown extends Component<Props,Status> {

    constructor (props: any) {
        super(props)

        this.state = {
            buttonsLayerIsOpen: false,
            modalLoginIsOpen: false,
            modalRegisterIsOpen: false,
        }

        this.toogleLayer = this.toogleLayer.bind( this )
        this.showLoginModal = this.showLoginModal.bind(this)
        this.showRegisterModal = this.showRegisterModal.bind(this)

        this.updateUser = this.updateUser.bind(this)

        this.switchModal = this.switchModal.bind(this)
        this.closeAllModals = this.closeAllModals.bind(this)
    }


    render(): ReactNode {
        return (
            <>
                <div
                    id='login-dropdown-container'
                >
                    {/* stampa il bottone "accedi" */}
                    <span 
                        className='dropdown-toggle cursor-pointer'
                        onClick={this.toogleLayer}
                    >
                        { loginIcon() } <span>Accedi</span>
                    </span>

                    {/* stampa il layer con i bottoni "accedi / registrati" */}
                    { this.state.buttonsLayerIsOpen &&
                        <span
                            className='dropdown-action-select'
                        >
                            <span
                                className='actions'
                            >
                                <button
                                    className='action accedi'
                                    type='button'
                                    onClick={this.showLoginModal}
                                >
                                    Accedi
                                </button>

                                <span className='separator'>
                                    o
                                </span>

                                <button
                                    className='action registrati'
                                    type='button'
                                    onClick={this.showRegisterModal}
                                >
                                    Registrati
                                </button>
                            </span>
                        </span>
                    }
                </div>

                {/* stampa la modale di login */}
                <LoginModal
                    isOpen={this.state.modalLoginIsOpen}
                    updateUserCallBack={this.updateUser}
                    switchModalCallBack={this.switchModal}
                    closeModalCallBack={this.closeAllModals}
                />

                {/* stampa la modale di registrati */}
                <RegisterModal 
                    isOpen={this.state.modalRegisterIsOpen}
                    createUserCallBack={() => {}}
                    switchModalCallBack={this.switchModal}
                    closeModalCallBack={this.closeAllModals}
                />
            </>
        )
    }

    private toogleLayer () {
        let next = {
            buttonsLayerIsOpen: !this.state.buttonsLayerIsOpen
        }

        if (!this.state.buttonsLayerIsOpen)  {
            next = {
                ...next,
                ...{
                    modalLoginIsOpen: false,
                    modalRegisterIsOpen: false,
                }
            }
        }

        this.setState( next )
    }

    private showLoginModal () {
        this.setState({
            buttonsLayerIsOpen: false,
            modalLoginIsOpen: true,
            modalRegisterIsOpen: false
        })
    }

    private showRegisterModal () {
        this.setState({
            buttonsLayerIsOpen: false,
            modalLoginIsOpen: false,
            modalRegisterIsOpen: true
        })
    }

    private closeAllModals () {
        this.setState({
            modalLoginIsOpen: false,
            modalRegisterIsOpen: false
        })
    }

    private switchModal () {
        this.setState({
            modalLoginIsOpen: !this.state.modalLoginIsOpen,
            modalRegisterIsOpen: !this.state.modalRegisterIsOpen,
        })
    }

    private updateUser ( user: UserType | undefined ) {
        this.setState({
            modalLoginIsOpen: user !== undefined
        }, () => {
            this.props.updateUserCallBack( user )
        })
    }
}

export default LoginDropDown